export namespace BacklogPaneIds {
    export const Off = "off";
    export const Planning = "planning";
    export const Mapping = "mapping";
}